import { createRipples } from './createRipples';
import withAttrs from './withAttrs';
export default withAttrs(createRipples());
export * from './createRipples';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-ripples/esm/index.js
// module id = 1646
// module chunks = 0